/* eslint-disable react/jsx-fragments */
import React from 'react';
import * as Ui from './styles';

function TextHint({
  controlId,
  tooltip,
  className,
  children,
}) {
  function tooltipText(_tooltip, _children) {
    if (_tooltip && typeof _tooltip === 'string') {
      return _tooltip;
    }
    if (_children && typeof _children === 'string') {
      return _children;
    }
    return null;
  }

  return (
    <React.Fragment>
      <div className={className} data-tip={tooltipText(tooltip, children)} data-for={controlId}>{children}</div>
      <Ui.ReactTooltipStyled
        id={controlId}
        place="top"
        type="dark"
        effect="solid"
        backgroundColor={'#610082'}
        arrowColor={'#610082'}
        delayShow={1000}
      />
    </React.Fragment>
  );
}

export default TextHint;
export { TextHint };
